export default __webpack_public_path__ + "static/media/KHLogo.bb29b59d.png";